module.exports = __webpack_public_path__ + "img/74.ce19e160.png";